import styles from './index.module.scss';
import ProListpageTop from '../components/ProListpageTop'
import ProjectListItem from '../../components/ProjectListItem'
import { useState, useEffect, useContext, useMemo, useRef } from 'react';
import { Pagination, message, Tabs, Spin } from 'antd';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import Utils from '@utils/utils'
import API, { commonApiInvoker } from '@api/api.js';
import { ProjectContext } from '../../hooks/ProjectContext'
import PSAIModal from '@PSAIComponents/PSAIModal';
import { AppContext } from '@utils/AppContext';
import { IMAGE_TYPE } from '@utils/CONST';
import { getFlowProjectHistoryImagesBatch, getFlowProjectPage } from '../../FreeCanvas/execution';
import { useLocation, useNavigate } from 'react-router-dom';

const FLOW_OPS_BY = 'zp6077';
const INVALID_FILE_NAME_REG = /[\\/:*?"<>|]/g;

const normalizeImageUrl = (value = '') => String(value || '').replace(/`/g, '').trim();
const sanitizeFileName = (value = '') => String(value || '').replace(INVALID_FILE_NAME_REG, '_').trim();

const getUniqueZipPath = (filePath, usedPaths) => {
    if (!usedPaths.has(filePath)) {
        usedPaths.add(filePath);
        return filePath;
    }

    const extensionIndex = filePath.lastIndexOf('.');
    const basePath = extensionIndex > filePath.lastIndexOf('/') ? filePath.slice(0, extensionIndex) : filePath;
    const extension = extensionIndex > filePath.lastIndexOf('/') ? filePath.slice(extensionIndex) : '';
    let suffix = 2;
    let uniquePath = `${basePath}(${suffix})${extension}`;

    while (usedPaths.has(uniquePath)) {
        suffix += 1;
        uniquePath = `${basePath}(${suffix})${extension}`;
    }

    usedPaths.add(uniquePath);
    return uniquePath;
};

const getImageExtension = (blob, url = '') => {
    const mimeExtension = blob?.type?.split('/')?.[1]?.split('+')?.[0];
    if (mimeExtension) return mimeExtension;
    const cleanUrl = String(url || '').split('?')[0];
    const matched = cleanUrl.match(/\.([a-zA-Z0-9]+)$/);
    return matched?.[1] || 'png';
};

const pushCandidateImage = (list, value) => {
    const imageUrl = normalizeImageUrl(value);
    if (!imageUrl || list.includes(imageUrl)) return;
    list.push(imageUrl);
};

const getFlowProjectPreviewImages = (project) => {
    const previewImages = [];
    const coverList = Array.isArray(project?.cover)
        ? project.cover
        : (project?.cover ? [project.cover] : []);

    coverList.forEach((item) => pushCandidateImage(previewImages, item));
    if (previewImages.length >= 2) return previewImages.slice(0, 2);

    const nodes = Array.isArray(project?.nodes) ? project.nodes : [];
    nodes.forEach((node) => {
        if (previewImages.length >= 2) return;

        const uploadValues = node?.renderData?.data?.panelState?.uploads
            ? Object.values(node.renderData.data.panelState.uploads)
            : [];
        const imageUrls = Array.isArray(node?.inputParams?.imageUrls) ? node.inputParams.imageUrls : [];

        [
            node?.renderData?.data?.src,
            node?.inputParams?.srcImage,
            node?.inputParams?.refImage,
            node?.inputParams?.commodityImage,
            ...imageUrls,
            ...uploadValues,
        ].forEach((item) => pushCandidateImage(previewImages, item));
    });

    return previewImages.slice(0, 2);
};

const mapFlowProjectToListItem = (item = {}) => {
    const previewImages = getFlowProjectPreviewImages(item);
    return {
        id: item.id,
        projectName: item.projectName || item.name || '未命名项目',
        updatedTime: item.updatedTime || '',
        userId: item.userId || '',
        memberName: item.memberName || '',
        mainImage: previewImages[0] || '',
        previewImages,
        flowProject: true,
        typeTitle: 'AI创意设计',
    };
};

const ProjectListPage = () => {
    const {
        proOrder,
        proSortField,
        proFunction,
        projectName,
        tabKey, setTabKey
    } = useContext(ProjectContext)

    const { proSidebarValue, globalOrgInfo, globalUser, member, setMember } = useContext(AppContext);
    const location = useLocation();
    const navigate = useNavigate();
    const consumedStateTabRef = useRef(false);

    const [pageIndex, setPageIndex] = useState();
    const [pageSize, setPageSize] = useState()
    const [list, setList] = useState([])
    const [total, setTotal] = useState()
    const [isSelected, setIsSelected] = useState(false) // 是否选择
    const [selectedList, setSelectedList] = useState([]) // 已选列表
    const [downLoading, setDownLoading] = useState(false)
    const [bookCover, setBookCover] = useState() //收藏封面
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [loading, setLoading] = useState(true)


    const items = [
        { key: '1', label: '个人项目' },
        { key: '2', label: '企业项目成员' }
    ]

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const queryTab = searchParams.get('tab');
        const stateTab = consumedStateTabRef.current ? '' : String(location.state?.tab || '');
        const nextTab = queryTab || stateTab;
        if (nextTab === '1' || nextTab === '2') {
            setTabKey(nextTab);
            if (!queryTab && stateTab) {
                consumedStateTabRef.current = true;
                navigate({
                    pathname: location.pathname,
                    search: location.search,
                }, { replace: true, state: null });
            }
            return;
        }
        if (!consumedStateTabRef.current) {
            setTabKey('1');
        }
    }, [location.pathname, location.search, location.state, navigate, setTabKey]);

    const requestModule = proSidebarValue === IMAGE_TYPE.CREATIVE_IMAGE_GEN ? 'creativeImage' : proSidebarValue
    const requestFunction = proSidebarValue === IMAGE_TYPE.CREATIVE_IMAGE_GEN ? IMAGE_TYPE.CREATIVE_IMAGE_GEN : proFunction
    const isFlowCreativeProject = proSidebarValue === IMAGE_TYPE.CREATIVE_IMAGE_GEN;
    const showLeadingCard = true;

    useEffect(() => {
        if (globalOrgInfo?.current?.role != 'admin') return
        if (tabKey == '1') {
            setMember(globalUser?.id)
        } else {
            setMember('team')
        }
    }, [tabKey])

    const tabChange = key => {
        setLoading(true)
        setList([])
        setSelectedList([])
        setTotal(0)
        setPageIndex(1)
        setTabKey(key)
    }
    useEffect(() => {
        if (!globalUser?.id) return
        if (tabKey == '1') {
            setMember(globalUser?.id)
        }
    }, [globalUser?.id, tabKey])

    const onChange = pageNumber => {
        sessionStorage.setItem('projectListPageIndex', pageNumber)
        setPageIndex(pageNumber)
    };

    useEffect(() => {
        setTimeout(() => {
            let index = sessionStorage.getItem('projectListPageIndex') || 1
            if (index) setPageIndex(Number(index))
            setIsFirstLoad(false)
        }, 150)
    }, [])

    // 每行可以展示多少个项目
    const calculateColumns = () => {
        const width = window.innerWidth;
        if (width >= 1800) return 6;
        if (width >= 1600) return 5;
        if (width >= 1200) return 4;
        return 3;
    }

    const [filterVersion, setFilterVersion] = useState(0)

    useEffect(() => {
        if (!pageIndex) return
        if (!localStorage.getItem('token')) { setLoading(false); return }
        listProjectv2()
    }, [pageIndex, filterVersion, proOrder, proSortField])

    useEffect(() => {
        if (isFirstLoad) return
        if (!isFirstLoad) sessionStorage.removeItem('projectListPageIndex')
        setLoading(true)
        setList([])
        setSelectedList([])
        setTotal(0)
        // 强制触发请求
        setFilterVersion(v => v + 1)
        setPageIndex(1)
    }, [proSidebarValue, proFunction, projectName, member])

    useEffect(() => {
        listBookmarkTaskv2()
    }, [member, proSidebarValue, proFunction, projectName])

    const listBookmarkTaskv2 = async () => {
        if (isFlowCreativeProject) {
            setBookCover();
            return;
        }
        const res = await commonApiInvoker(
            API.listBookmarkTaskv2({
                module: requestModule,
                member: member == 'team' ? null : member ? member : globalUser?.id
            })
        )
        const filteredRes = proSidebarValue === IMAGE_TYPE.CREATIVE_IMAGE_GEN
            ? res.filter(item => item?.imageType === IMAGE_TYPE.CREATIVE_IMAGE_GEN)
            : res
        if (filteredRes.length > 0) {
            const image = filteredRes[0]?.results?.[0]?.image;
            if (image && (image.endsWith('.mp4') || image.endsWith('.MP4'))) {
                setBookCover(filteredRes[0]?.inputImage);
            } else {
                setBookCover(image);
            }
        } else setBookCover()
    }

    const listProjectv2 = () => {
        const columns = calculateColumns()
        let pageIndexCalc = columns * 3 - 1
        if (isFlowCreativeProject) {
            pageIndexCalc += columns
        }
        if (isFlowCreativeProject) {
            getFlowProjectPage({
                keyword: projectName || '',
                order: proOrder,
                sortField: proSortField,
                pageIndex: pageIndex,
                pageSize: pageIndexCalc,
                member: member == 'team' ? null : member ? member : globalUser?.id,
            }).then(res => {
                const nextItems = Array.isArray(res?.items) ? res.items.map(mapFlowProjectToListItem) : [];
                setList(nextItems)
                setPageSize(res.pageSize)
                setTotal(res.total)
            }).finally(() => {
                setLoading(false)
            })
            return
        }
        commonApiInvoker(API.listProjectv2({
            pageIndex: pageIndex,
            pageSize: pageIndexCalc,
            module: requestModule,
            order: proOrder,
            sortField: proSortField,
            function: requestFunction,
            projectName: projectName,
            member: member == 'team' ? null : member ? member : globalUser?.id
        })).then(res => {
            setList(res.items)
            setPageSize(res.pageSize)
            setTotal(res.total)
        }).finally(() => {
            setLoading(false)
        })
    }

    const getIsSelected = (flag) => {
        setIsSelected(flag)
    }
    const selectCurrentItem = (id) => {
        if (selectedList.includes(id)) {
            setSelectedList(selectedList.filter(item => item !== id))
        } else {
            setSelectedList([...selectedList, id])
        }
    }

    const selectAll = () => {
        if (isSelectedAll) {
            setSelectedList([])
        } else {
            setSelectedList(list.map(item => item.id))
        }
    }

    const isSelectedAll = useMemo(() => {
        if(list.length == 0) return false
        return list.length == selectedList.length
    }, [selectedList])

    const deleteClick = () => {
        if (selectedList.length == 0) return
        PSAIModal.confirm({
            title: "删除项目",
            content: "删除后项目将无法找回，确定删除吗？",
            onOk: deleteProject
        })
    }
    const deleteProject = () => {
        if (isFlowCreativeProject) {
            commonApiInvoker(API.deleteFlowProject({
                projectIds: selectedList,
                opsBy: FLOW_OPS_BY,
            }), false, true).then(() => {
                message.success('项目已删除');
                setSelectedList([])
                listProjectv2()
            })
            return
        }
        commonApiInvoker(API.projectBatchMove({
            ids: selectedList
        })).then(res => {
            message.success('删除成功');
            setSelectedList([])
            listProjectv2()
        })
    }

    const downClick = () => {
        if (selectedList.length == 0) return
        // const status = Utils.checkFirstDownLoad(() => downClickMeta())
        // if (!status) return
        downClickMeta()
    }

    const downClickMeta = () => {
        if (isFlowCreativeProject) {
            setDownLoading(true)
            getFlowProjectHistoryImagesBatch({
                projectIds: selectedList,
            }).then(async (projectList) => {
                const zip = new JSZip();
                const usedZipPaths = new Set();
                let imageCount = 0;

                await Promise.all((Array.isArray(projectList) ? projectList : []).map(async (projectItem, projectIndex) => {
                    const projectName = sanitizeFileName(projectItem?.projectName || `项目${projectIndex + 1}`) || `项目${projectIndex + 1}`;
                    const nodes = Array.isArray(projectItem?.nodes) ? projectItem.nodes : [];

                    await Promise.all(nodes.map(async (nodeItem, nodeIndex) => {
                        const nodeName = sanitizeFileName(nodeItem?.nodeName || `节点${nodeIndex + 1}`) || `节点${nodeIndex + 1}`;
                        const images = Array.isArray(nodeItem?.images) ? nodeItem.images.filter(Boolean) : [];

                        await Promise.all(images.map(async (imageUrl, imageIndex) => {
                            const response = await fetch(imageUrl);
                            if (!response.ok) {
                                throw new Error('下载图片失败');
                            }

                            const blob = await response.blob();
                            const extension = getImageExtension(blob, imageUrl);
                            const filePath = getUniqueZipPath(
                                `${projectName}/${nodeName}-${imageIndex + 1}.${extension}`,
                                usedZipPaths,
                            );
                            zip.file(
                                filePath,
                                blob,
                            );
                            imageCount += 1;
                        }));
                    }));
                }));

                if (imageCount === 0) {
                    message.warning('未找到可下载的结果图');
                    return;
                }

                const zipBlob = await zip.generateAsync({ type: 'blob' });
                saveAs(zipBlob, `AI创意设计结果图-${Date.now()}.zip`);
                message.success('下载成功');
            }).catch(() => {
                message.warning('下载失败，请稍后重试');
            }).finally(() => {
                setDownLoading(false)
            })
            return
        }
        setDownLoading(true)
        commonApiInvoker(API.projectPatchDownload({
            ids: selectedList
        }), setDownLoading).then(res => {
            Utils.downloadFileWithToken(res).then(() => {
                message.success('下载成功');
            }).catch(() => {
                setDownLoading(false)
                message.warning('下载失败，请稍后重试');
            }).finally(() => {
                setDownLoading(false)
            })
        }).catch(() => {
            setDownLoading(false)
        }).finally(() => {
            setDownLoading(false)
        })
    }

    const pageCount = useMemo(() => {
        return false
    }, [list])


    return (
        <div className={styles.ProjectListPage} style={{ justifyContent: 'flex-start' }}>
            <ProListpageTop
                getIsSelected={getIsSelected}
                setSelectedList={setSelectedList}
                selectedList={selectedList}
                isSelectedAll={isSelectedAll}
                downLoading={downLoading}
                selectAll={selectAll}
                downClick={downClick}
                deleteClick={deleteClick}
                tabKey={tabKey}
                setMember={setMember}
                member={member}
            />
            <div
                className={`${styles.ProjectListItems} ${isFlowCreativeProject ? styles.FlowProjectListItems : ''} _beauty_scrollbar`}
                style={{
                    padding: pageCount ? '60px 0' : '20px',
                }}>
                {
                    (globalOrgInfo?.current?.role == 'admin') &&
                    <Tabs items={items} activeKey={tabKey} onChange={tabChange} style={{ width: '100%' }} />
                }
                {loading && list.length === 0 ? (
                    <div style={{ width: '100%', minHeight: 320, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Spin size="large"></Spin>
                    </div>
                ) : (
                    <>
                        {showLeadingCard ? (
                            <div className={`${styles.ItemBox} ${isFlowCreativeProject ? styles.FlowItemBox : ''}`} >
                                <ProjectListItem
                                    item={{
                                        id: isFlowCreativeProject ? 'create-flow-project' : 'collect',
                                        mainImage: bookCover || 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/collectPro.png',
                                        projectName: isFlowCreativeProject ? '新建项目' : (tabKey == '1' ? '我的收藏' : '企业收藏'),
                                        flowProject: isFlowCreativeProject,
                                        createFlowCard: isFlowCreativeProject,
                                    }}
                                    isEnterpriseMemberTab={tabKey == '2'}
                                    flowCreativePreview={isFlowCreativeProject}
                                    listProjectv2={listProjectv2}
                                    isSelected={false} />
                            </div>
                        ) : null}
                        {
                            list.map((item) => (
                                <div
                                    className={`${styles.ItemBox} ${isFlowCreativeProject ? styles.FlowItemBox : ''}`}
                                    key={item.id}
                                >
                                    <ProjectListItem
                                        item={item}
                                        isEnterpriseMemberTab={tabKey == '2'}
                                        flowCreativePreview={isFlowCreativeProject}
                                        listProjectv2={listProjectv2}
                                        isSelected={isSelected}
                                        selectedList={selectedList}
                                        selectCurrentItem={selectCurrentItem} />
                                </div>
                            ))
                        }
                    </>
                )}
            </div>
            {
                <div className={styles.ProjectListPagination}>
                    <Pagination
                        showQuickJumper
                        total={total}
                        onChange={onChange}
                        pageSize={pageSize}
                        current={pageIndex}
                        showSizeChanger={false} />
                </div>
            }
        </div>
    )
}

export default ProjectListPage
